/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
export default {
  'sidebar.smartstock': 'Smart Stock',
  'sidebar.tiposunidades': 'Tipos Unidades',
  'tiposUnidades.agregarTiposUnidades': 'Crear Tipos Unidades',
  'tiposUnidades.modificarTiposUnidades': 'Editar Tipos Unidades',
  'tiposUnidades.tipoUnidadId': 'Tipo Unidad Id',
  'tiposUnidades.empresaId': 'Empresa Id',
  'tiposUnidades.descripcionTipoUnidad': 'Descripción Tipo Unidad',
  'tiposUnidades.VerTiposUnidades': 'Ver Tipos Unidades',
};
